(function() {
    'use strict';

    // ? VARIABLES 
    var cerrado     = true;
    var menuLat     = false; 
    var resEnPantalla = 0;

    let heros = [];      

    // Obtener todos los enlaces del menú en un array
    const menuLinks = Array.from(document.querySelectorAll('.nav_links'));    

    window.onload = (event) => {

        iniciarClicks();


        console.log('Aquí si llega');
        
        //! LLENAR LA INFORMACIÓN DE UN PRODUCTO
        const productoId = getParameterByName('id');            

        if (productoId !== null) {
            console.log('Va a llenar el detalle de un producto');
            
            mostrarDetallesProducto(productoId);
        } else {

            console.log('Debe de llenar toda la lista de productos');
            
            //! LLENANDO EL CONTENEDOR DE LOS PRODUCTOS
            llenaProductos(); 
        }


        // ! Escuchar el evento de desplazamiento y actualizar la clase 'nav_active'
        window.addEventListener('scroll', updateActiveClass);

        // ! Actualizar la clase 'nav_active' cuando la página se carga
        window.addEventListener('load', updateActiveClass);        

        //! LLENAR LOS BANNERS DE PUBLICIDAD
        const div_pub = document.getElementById('div_pub');

        if (div_pub !== null) {
            llena_bannerspub(div_pub);             
        };

    };

    //! =================================================================================
    //* Función que activa el monitoreo de los clics y el scroll
    //! =================================================================================

    function iniciarClicks() {
            
        document.addEventListener('click', (e) => {
            e.preventDefault();
            clicksWeb(e.target);
        });

        window.addEventListener('scroll', function() {
            navBackground();
        })
        navBackground();

        if (document.getElementById("fondosHero")) {
            heros = document.querySelectorAll('.fondo_hero');
            setInterval(next_fondo, 3000); 
        }

    }

    //! =================================================================================
    //* Función que ejecuta los diferentes clicks de la página
    //! =================================================================================

    function clicksWeb(objetoDom) {

        // console.log(objetoDom);

        if (objetoDom.hasAttribute('idclick')) {

            const valorIdClick = objetoDom.getAttribute('idclick');
            const valorIdProducto = objetoDom.getAttribute('idproducto');

            // fetch('../../assets/file_clicks.json')

            const clicksJsonPath = `${getBaseURL()}assets/file_clicks.json`;

            fetch(clicksJsonPath)
            .then(response => response.json())
            .then(data => {
      
                let lista_clicks = data;

                // Buscar el registro con tipo="pagina" y clave="01"
                let reg_click = data.clicks.find(function(item) {
                    return item.idclick === valorIdClick;
                });

                let tipo_click = reg_click.tipo;
                switch ( tipo_click ) {

                    case "link":

                        let url = reg_click.href;

                        if (!url) {
                            url = objetoDom.href
                            console.log(url);
                        
                        }

                        if (valorIdProducto !== null) {
                            url += "?id=" + valorIdProducto
                        }

                        window.open(url,reg_click.ventana);
                        break;

                    case "function":

                        let idfunc = reg_click.idfunc;
                        let href = reg_click.href;

                        switch (idfunc) {

                            case "01":
                                moveToSection(href);
                                break;

                            case "02":
                                reproduce_video_youtube(objetoDom);
                                break;
                                                            
                            case "03":
                                linkToPub(objetoDom);
                                break;

                            case "06":
                                toggleAccordion(objetoDom);
                                break;
                            
                            case "07":
                                menuLat = true;
                                apertura();
                                break;
    
                            default:
                                break;
                        }
                        break;    

                    default:
                        break;
                }

          
            })
            .catch(error => {
                console.log('Error al cargar el archivo JSON:', error);
            });
        }
        

    } 
    
    //! =================================================================================
    //* Función para llenar el slider de los banners de publicidad
    //! =================================================================================

    function llena_bannerspub(div_pub) { 

        let divIndicadores = document.getElementById('div_indicadores');

        div_pub.innerHTML = '';
        divIndicadores.innerHTML = '';

        // fetch('../../assets/patros.json')
        const patrosJsonPath = `${getBaseURL()}assets/patros.json`;
        
        fetch(patrosJsonPath)
            .then(response => response.json())
            .then(data => {
                                    
                const anuncios = data.anuncios;
                let i = 0;

                anuncios.forEach(anuncio => {

                    // ! Creando los botones de los indicadores del carrusel
                    let button = document.createElement("button");
                    button.setAttribute("type", "button");
                    button.setAttribute("data-bs-target", "#crs_pub");
                    button.setAttribute("data-bs-slide-to", i.toString());                    

                    const link_anuncio = document.createElement('div');

                    link_anuncio.classList.add('carousel-item');
                    if (i===0) {
                        button.classList.add("active");                            
                        link_anuncio.classList.add('active');
                    }
                    i++;

                    link_anuncio.innerHTML = ` 

                        <a href="${anuncio.href}">
                            <picture>
                                <source srcset="build/img/banners_pub/${anuncio.clave}.avif" type="image/avif">
                                <source srcset="build/img/banners_pub/${anuncio.clave}.webp" type="image/webp">
                                <img src="build/img/banners_pub/${anuncio.clave}.jpg" alt="Banner publicitario" idclick="016" class="d-block fto-img-pub" style="width:100%">
                            </picture>    
                        </a>
                    
                    `;

                    // Agrega la anuncio al contenedor 
                    divIndicadores.appendChild(button);                       
                    div_pub.appendChild(link_anuncio);
                });
            })
        .catch(error => {
            console.error('Error al obtener los datos del archivo JSON:', error);
        });                      
    
    }

    //! =================================================================================
    //* Función para moverme automáticamente a una sección de la página
    //! =================================================================================
    
    function moveToSection(sectionId) {
        // Si se pasa "top" como sección, se desplaza al inicio de la página
        if (sectionId === 'top') {
            window.scrollTo({top: 0, behavior: 'smooth'});
            return;
        }
      
        // Busca el elemento con el ID proporcionado
        const element = document.getElementById(sectionId);
      
        // Si el elemento existe, se desplaza a él
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
        } else {
            console.warn(`Elemento con ID ${sectionId} no encontrado.`);
        }
      }
      
    //! =================================================================================
    //* Función para abrir el menú lateral cuando el tamaño sea tablet o inferior
    //! =================================================================================

    function apertura() {
        let menu    = document.getElementById('navPrincipal');
        let botSubir = document.getElementById('botInicio');
        let botAccWP	 = document.getElementById('botWP');
        
        if (cerrado) {
            menu.style.width = '100vw!important';
            cerrado = false;
            
            if (botSubir) {
                botSubir.style.visibility = 'hidden';
                botAccWP.style.visibility = 'hidden';
            }

        } else {
            menu.style.width = '0%';
            menu.style.overflow = 'hidden';
            cerrado = true;
            menuLat = false;
            if (botSubir) {
                botSubir.style.visibility = 'visible';
                botAccWP.style.visibility = 'visible';
            }
        }
        menu.classList.toggle('menu2');
    };   

    //! =================================================================================
    //* Función para activar el efecto de las prefuntas frecuentes
    //! =================================================================================

    function toggleAccordion(elem) {

        let elemFaq;
        let i;

        if (elem.matches('.btnFaq') === false) {
            elemFaq = elem.parentNode;
        } else {
            elemFaq = elem;
        }

        const items = document.querySelectorAll(".accordion button");
        const itemToggle = elemFaq.getAttribute('aria-expanded');
        
        for (i = 0; i < items.length; i++) {
          items[i].setAttribute('aria-expanded', 'false');
        }
        
        if (itemToggle == 'false') {
          elemFaq.setAttribute('aria-expanded', 'true');
        }
    }
    
    //! =================================================================================
    //* Función para cambiar el color de fondo de la barra de menú según la posición de la pantalla
    //* Si está en el top, es transparente, si no se le pone un color obscuro
    //! =================================================================================

    function navBackground() {

        let nav = document.querySelector('.nav');
        let desp_actual = window.pageYOffset;
        let ancho_screen = window.innerWidth;        

        if ( desp_actual <= 300 ) {

            nav.style.borderBottom = ''; 

            if (ancho_screen > 768 ) {
                nav.style.background = 'rgba(0,0,0,0.5)';
            } else {
                nav.style.background = 'linear-gradient(0deg, rgba(0,0,0,0) 5%, rgba(0,0,0,1) 100%)';
            }

        } else {
            nav.style.background = '#1F2022';
            nav.style.borderBottom = '2px solid #003b83';
        }
        nav.style.transition = '.5s';
    }

    function next_fondo() {
        let idxHero = actBanner(heros, 0);      
        nextBanner(heros, idxHero, '+');        
    }

    function actBanner(array, idxBan) {
        while (idxBan < array.length) {
            if (array[idxBan].classList.contains('banner_visible')) {
                break;
            }
            idxBan++;
        }
        return idxBan;
    }

    function nextBanner(array, idx, opr) {
        let idxNext = idx;
        if (opr==='+') {
            idxNext++;
            if (idxNext > array.length - 1) {
                idxNext = 0;
            }    
        } else {
            --idxNext;
            if (idxNext < 0) {
                idxNext = array.length - 1;
            }
        }
        array[idx].classList.remove('banner_visible');
        array[idxNext].classList.add('banner_visible');
    }


    //! =================================================================================
    //* Función para marcar las opciones del menú dependiendo de la posición 
    //* en la que se encuentre en pantalla
    //! =================================================================================

    function updateActiveClass() {
        let found = false;
    
        // Primero, quitar la clase 'nav_active' de todos los elementos
        menuLinks.forEach(link => link.parentElement.classList.remove('nav_active'));

        // Iterar a través de cada enlace del menú
        for (const link of menuLinks) {
            const sectionId = link.getAttribute('href').substring(1); // Eliminar el '#' del href
            const section = document.getElementById(sectionId);

            if (section) {
                const rect = section.getBoundingClientRect();

                // Comprobar si la sección está en la ventana de visualización
                if (rect.top <= window.innerHeight / 2 && rect.bottom >= window.innerHeight / 2) {

                    link.parentElement.classList.add('nav_active');
                    found = true;

                } else {

                    link.parentElement.classList.remove('nav_active');

                }
            }
        }

        // Si ninguna sección coincide, establecer 'Inicio' como activo
        if (!found) {
            document.querySelector('[idclick="001"]').parentElement.classList.add('nav_active');
        }
    }

    //! =================================================================================
    //* Función para reproducir vídeos de Youtube directamente en la página
    //! =================================================================================

    function reproduce_video_youtube(obj) {

        const parentPadre = obj.parentNode.parentNode.parentNode;
        const iframeElement = parentPadre.querySelector(".youtube-video iframe");
        iframeElement.setAttribute("src", null );  // Autoplay y mute
 
        const parentElement = obj.parentNode.parentNode;
        parentElement.remove();
         
        iframeElement.setAttribute("src", "https://www.youtube.com/embed/"+obj.dataset.embed+"?autoplay=1" );  // Autoplay y mute
         
     }
 
    //! =================================================================================
    //* Abre el enlace de uno de los banners de publicidad
    //! =================================================================================

    function linkToPub(obj) {
        
        const hrefValue = obj.parentNode.parentNode.getAttribute('href');
        window.open(hrefValue, '_blank');

    }

    //! =================================================================================
    //* Función para obtener el valor del parámetro "id" desde la URL
    //! =================================================================================

    function getParameterByName(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }


    //! =================================================================================
    //* Función para cargar y mostrar los detalles del producto desde el archivo JSON
    //! =================================================================================

    function mostrarDetallesProducto(id) {

        // fetch('../../assets/productos.json') 

        const productosJsonPath = `${getBaseURL()}assets/productos.json`;

        fetch(productosJsonPath) 
            .then(response => response.json())
            .then(data => {

                // Buscar el producto por su ID en el archivo JSON
                const datosProducto = data.productos.find(producto => producto.idproducto === id);

                if (datosProducto) {


                    // ! Visualizando la imagen de fondo del producto
                    // const fondoHeroProd = document.getElementById('fondoProducto');
                    // if (fondoHeroProd !== null) {
                    //     fondoHeroProd.innerHTML = `
                    //         <picture>
                    //             <source srcset="build/img/productos/fs_${id}.avif" type="image/avif">
                    //             <source srcset="build/img/productos/fs_${id}.webp" type="image/webp">
                    //             <img width="350" height="150" src="build/img/productos/fs_${id}.jpg" alt="Fondo de Pantalla TEXTOS DE IMPACTO">
                    //         </picture>
                    //     `;
                    // }

                    // ! Visualizando los datos del encabezado                    
                    const secTitulo = document.getElementById('secTituloH1');
                    if (secTitulo !== null) {
                        secTitulo.innerHTML = `
                            <h1>${datosProducto.titulo}</h1>
                            <p>${datosProducto.dcorta}</p>
                
                            <div class="precio-producto">
                                <p class="precio">${datosProducto.precio} mx</p>
                                <p class="notas-precio"><i class="fas fa-info-circle"></i> ${datosProducto.notasprecio}</p>
                                <a href="${datosProducto.linkpago}" idclick="032" class="boton">Comprar</a>
                            </div>
                        `;
                    }

                    // ! Visualizando los detalles del producto
                    const secDetalles = document.getElementById('detalle-producto');
                    if (secDetalles !== null) {
                        secDetalles.innerHTML = `
                            <h2>${datosProducto.titulo}</h2>
                            <p>${datosProducto.dlarga}</p>
                            <p class="notas-producto"><i class="far fa-clock"></i> ${datosProducto.tiempo}</p>
                            <p class="notas-producto" id="notas"><i class="fas fa-hand-point-right"></i> ${datosProducto.notas}</p>
                        `;
                    }

                    // ! Visualizando el precio del producto
                    const secPrecio = document.getElementById('precio-producto');
                    if (secPrecio !== null) {
                        secPrecio.innerHTML = `
                            <p class="precio">${datosProducto.precio} mx</p>
                            <p class="notas-precio"><i class="fas fa-info-circle"></i> ${datosProducto.notasprecio}</p>
                            <a href="${datosProducto.linkpago}" idclick="032" class="boton">Comprar</a>
                        `;
                    }

                    // ! Ocultando las notas de los precios cuando el valor de notasprecio es vacío
                    if (!datosProducto.notasprecio) {
                        // Seleccionar ambos elementos con la clase "notas-precio"
                        const elementos = document.querySelectorAll('.notas-precio');
                        
                        // Recorrer los elementos y asignar la clase para hacerlos invisbles
                        elementos.forEach(elemento => {
                            elemento.classList.add('nomostrar');
                        });
                    }
                      
                    // ! Ocultando las notas del producto cuando el valor de notas es vacío
                    if (!datosProducto.notas) {
                        const notas = document.getElementById('notas');
                        notas.classList.add('nomostrar');
                    }
                    
                    //! Visualizando los productos relacionados de la misma categoría
                    llenaProductos(datosProducto.categoria); 


                } else {
                    
                    console.log('El producto seleccionado no existe: ' + id);
                    console.log(datosProducto);
                    
                }
            })
        .catch(error => {
            console.error('Error al obtener los datos del archivo JSON:', error);
        });
    }

    //! =================================================================================
    //* Functión para llenar el contenedor de los productos.
    //* 1) Si la función recibe un nombre de categoría, entonces muestra solo los productos de esa categoría
    //* 2) Si no recibe categoría, entonces valida si se deben de mostrar solo los productos de la pantalla principal
    //* 3) Si no está el atributo productos-principales, entonces visualizará todos los productos.
    //! =================================================================================
    
    function llenaProductos(idcategoria = '') {

        const secProductos = document.getElementById('sec-productos');

        if (secProductos !== null) {        

            // Verificar si existe el elemento y contiene la clase "productos-principales"
            const mostrarSoloPrincipales = secProductos.classList.contains('productos-principales');

            // console.log(secProductos);            
            // console.log(mostrarSoloPrincipales); 
            
            // Leer el archivo productos.json
            // fetch('../../assets/productos.json')

            const productosJsonPath = `${getBaseURL()}assets/productos.json`;

            fetch(productosJsonPath)
                .then(response => response.json())
                .then(data => {

                    const productos = data.productos;
                    secProductos.innerHTML = ''; // Limpiar el contenedor de productos

                    productos.forEach(producto => {

                        // Verificar si se deben mostrar solo los productos principales
                        if (mostrarSoloPrincipales && producto.paginaprincipal !== 'true') {
                            return; // Saltar al siguiente producto
                        }

                        // Verificar si se proporcionó un valor para idcategoria
                        if (idcategoria && producto.categoria !== idcategoria) {
                            return; // Saltar al siguiente producto
                        }

                        // Crear el HTML del producto y agregarlo al contenedor
                        const productoHTML = `
                            <div class="glbBox"> 
                                <div class="box_image">
                                    <picture>
                                        <source srcset="build/img/productos/producto-${producto.idproducto}.avif" type="image/avif">
                                        <source srcset="build/img/productos/producto-${producto.idproducto}.webp" type="image/webp">
                                        <img src="build/img/productos/producto-${producto.idproducto}.webp" class="img-fluid rounded-top glb-imagen-producto" alt="Imagen del producto seleccionado" idclick="${producto.idclick}" idproducto="${producto.idproducto}">
                                    </picture>                                    
                                </div>
                                <div class="box_content"> 
                                    <div class="box_texto">
                                        <a href="#" class="text-dark"><h5 idclick="${producto.idclick}" idproducto="${producto.idproducto}">${producto.titulo}</h5></a>
                                        <p class="text-muted">${producto.dcorta}</p>
                                    </div>
                                    <div class="box_footer"> 
                                        <span>${producto.precio}</span>
                                        <a href="#" title="Ver detalles" data-bs-toggle="popover" data-bs-trigger="focus" data-bs-content="Próximamente disponible." idclick="${producto.idclick}" idproducto="${producto.idproducto}"><i class="fas fa-info"></i> Ver Más</a>
                                    </div>
                                </div>
                            </div>
                        `;

                        secProductos.innerHTML += productoHTML;
                    });
                })
            .catch(error => {
                console.error('Error al obtener los productos del archivo JSON:', error);
            });
        }
    }

    //! =================================================================================
    //* Functión para obtener la ruta de las carpetas ASSETS.
    //* - Esta función se hizo para sustituir la forma de buscar un archivo, en lugar de usar ../../
    //* - Esto solo se usa en páginas web que estén dentro de una SUBCARPETA y no en el directorio raíz
    //* - Si la página web se encuentra dentro de una subcarpeta, ../../ no funciona.
    //! =================================================================================
    
    function getBaseURL() {
        // Comprueba si está en desarrollo o producción basado en el dominio
        const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname.includes('127.0.0.1');

        console.log(isDevelopment ? '/' : '/climas-aufit/');

        // Ajusta la ruta base dependiendo del entorno
        return isDevelopment ? '/' : '/climas-aufit/';

        
    }


})();